module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Devices/USB-b3f489322edcd9dfc9775b3846b38090a197af09584c3ea6a7597f9ab65b97b0.svg";